import React from 'react';
import Engagement from '../Images/engagement2.png';
import '../styles/Details.css';

function engagement() {
  return (
    <img src={Engagement} alt="engagement pictures" className='faqs-image' />
  );
}

export default engagement;
